'use strict';

import compareWidget from '../compare-widget';
import productTile from '../product-tile';
import progress from '../progress';
import video from '../video';
import util from '../util';
import filterPanel from './mobileFilterPanel';

function copyBottomResultHitsToTop() {
    $("#results-hits-top").html($("#results-hits-bottom .results-hits ").html());
}


/**
 * @private
 * @function
 * @description Allow to lazyload contents of PLP pages, search result pages and content pages
 */

// update url with current scroll product list
function getPageUpdateOnUrl() {
    $("#search-result-items").on('click', '.product-item', function (e) {
        localStorage.setItem("productPositionLastClicked", $(this).attr("id"));
        const url = new URL(window.location.toString().split('#')[0]);
        url.searchParams.set('page', $(this).data('page-number'));
        url.searchParams.set('start', $(this).data('page-start'));
        window.history.replaceState(null, null, url + '#' + $(this).attr("id"));
    });
};

// Check Top to bottom product list 
function viewMoreClick() {
    // getting the hidden div, which is the placeholder for the next page
    var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
    // get url hidden in DOM
    var gridUrl = loadingPlaceHolder.attr('data-grid-url');

    if (loadingPlaceHolder.length === 1 && util.elementInViewport(loadingPlaceHolder.get(0), 250)) {
        // switch state to 'loading'
        // - switches state, so the above selector is only matching once
        // - shows loading indicator
        $(".curalate-product").addClass("hide");
        loadingPlaceHolder.attr('data-loading-state', 'loading');
        loadingPlaceHolder.addClass('infinite-scroll-loading');

        // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
        var fillEndlessScrollChunk = function (html) {
            loadingPlaceHolder.removeClass('infinite-scroll-loading');
            loadingPlaceHolder.attr('data-loading-state', 'loaded');
            $('div.search-result-content').append(html);

            // move all product tiles up to search grid to prevent arbitrary breaklines
            if (!SitePreferences.MINIQUICKVIEW) {
                $(".tiles-container .column").appendTo("#search-result-items");
            }
            // rebind the View More event
            $("#view-more").off();
            $("#view-more").on("click", viewMoreClick);
            //remove back-page non required element
            var backPageID = $("#search-result-items .product-item:last").attr("data-page-number");
            $('#backpage-' + backPageID).remove();
        };

        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
        // it was removed to temporarily address RAP-2649

        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: gridUrl,
            success: function (response) {
                // put response into cache
                try {
                    sessionStorage['scroll-cache_' + gridUrl] = response;
                } catch (e) {
                    // nothing to catch in case of out of memory of session storage
                    // it will fall back to load via ajax
                }
                // update UI
                $("#view-more").remove();
          	    $("#view-all").remove();
                $(".results-hits").remove();
                if( !$.trim( $('.results-hits-empty').html() ).length ) {
                    $('.results-hits-empty').css('width', 'initial');
                };

                $('.next-page.pagination-buttons').remove(); // identifier to detect next page available or not
                fillEndlessScrollChunk(response);
                copyBottomResultHitsToTop();
                productTile.init();
                $(document).trigger("plpviewmore");

                var $showCuralateSection = $('div.search-result-content').find("input.showCuralateSection");
                if ($showCuralateSection && $showCuralateSection.length > 0) {
                    var showCuralate = $showCuralateSection.val();
                    if (showCuralate == "true") {
                        $(".curalate-product").removeClass("hide");
                    }
                }
                getPageUpdateOnUrl();
                // rebind lazyLoadingObserver after DOM updated 
                setTimeout(updateIntersectionObserver, 1000);
                setTimeout(() => {
                    var currentCount = $('.search-result-content .product-item').length;
                    var totalCount = $('#total-count').val();
                    $('.current-count').html($('.search-result-content .product-item').length  + ' of');
                    if (currentCount == totalCount) {
                        $('.current-count').empty();
                    }

                }, 1000);
            }
        });
    }
}

// Lazy loading top to bottom observer
function lazyLoadingObserver() {
    var targetElement,
        observer;
    // IntersectionObserver's config options
    var options = {
        root: null, // null represents viewport or provide DOM node
        rootMargin: "200px 0px 200px 0px", // works in clockwise direction
        threshold: 0.85 // starts oberving from 1px of target being visible in the view port [0, 0.1 = 10%, 0.5 = 50%... upto 1=100]

    };

    targetElement = document.querySelector('.next-page');
    if (typeof (targetElement) != 'undefined' && targetElement != null && !!window.IntersectionObserver) {
        observer = new IntersectionObserver(lazyLoadingObserverHandler, options);
        observer.observe(targetElement);
    }
}

// Lazy loading top to bottom observer handler
function lazyLoadingObserverHandler(entries, observer) {
    if (!$(".next-page").hasClass("temp-hide")) {
        for (var entry of entries) {
            if (entry.intersectionRatio >= 0.85) {
                viewMoreClick();
            }
        }
    }
}

// Lazy loading bottom to top observer
function lazyLoadingBottomToTopObserver() {
    var totalHeight = $("#search-result-items .product-item:first").outerHeight() != undefined ? ($("#search-result-items .product-item:first").outerHeight() / 2) : "200";
    totalHeight = totalHeight + "px 0px " + totalHeight + "px 0px";
    var targetElement,
        observer;
    // IntersectionObserver's config options
    var options = {
        root: null, // null represents viewport or provide DOM node
        rootMargin: totalHeight, // works in clockwise direction
        threshold: 0.85  // starts oberving from 1px of target being visible in the view port [0, 0.1 = 10%, 0.5 = 50%... upto 1=100]

    };
    targetElement = document.querySelector('.back-page');
    if (typeof (targetElement) != 'undefined' && targetElement != null && !!window.IntersectionObserver) {
        observer = new IntersectionObserver(lazyLoadingBottomToTopObserverHandler, options);
        observer.observe(targetElement);
    }
}

// Update Intersecting observer on viewport
function updateIntersectionObserver() {
    if (!!window.IntersectionObserver) {
        lazyLoadingObserver();
        if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
            initPLPSlider();
        }
        initColorShadesSliderPlp();
    }
}

// Lazy loading bottom to top observer 
function viewBottonToTopClick() {
    // getting the hidden div, which is the placeholder for the next page
    var backLoadingPlaceHolder = $('.infinite-scroll-placeholder-bottom-to-top[data-loading-state="unloaded"]');
    // get url hidden in DOM
    var gridUrl = backLoadingPlaceHolder.attr('data-grid-url');

    if (backLoadingPlaceHolder.length === 1) {
        // switch state to 'loading'
        // - switches state, so the above selector is only matching once
        // - shows loading indicator
        backLoadingPlaceHolder.attr('data-loading-state', 'loading');
        backLoadingPlaceHolder.addClass('infinite-scroll-loading');

        $('.back-page .inline-lazy-loader').show();

        // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
        var fillEndlessScrollChunk2 = function (html) {
            $(".back-page").remove();

            var newHtml = $(html);

            backLoadingPlaceHolder.removeClass('infinite-scroll-loading');
            backLoadingPlaceHolder.attr('data-loading-state', 'loaded');

            $('#results-hits-bottom').remove();

            if ($('.tutorial-listing').length > 0) {
                $('div.search-result-content').prepend(newHtml);
            } else if ($('.ordereplenishments').length > 0) {
                $('.ordereplenishments .replenishment-items').prepend(newHtml);
            } else if ($('.order-history-wrap').length > 0) {
                $('div.order-history-results').prepend(newHtml);
            } else {
                $('div.search-result-content').prepend(newHtml);
            }

            // move all product tiles up to search grid to prevent arbitrary breaklines
            $(".tiles-container .product-item").prependTo("#search-result-items");

            $('.back-page .inline-lazy-loader').hide();
            $(".back-page").prependTo("#search-result-items");

            //remove next-page non required element
            var nextPageID = $("#search-result-items .product-item:first").attr("data-page-number");
            $('#nextpage-' + nextPageID).remove();

            if ($('.search-result-items').is(':empty')) {
                $('.search-result-items').remove();
            }

            $('.product-tiles-holder').css('visibility', 'visible');
            maintainBackPageScroll();
        };

        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
        // it was removed to temporarily address RAP-2649
        if (gridUrl.length) {
            $.ajax({
                type: 'GET',
                dataType: 'html',
                url: gridUrl,
                success: function (response) {
                    // put response into cache
                    try {
                        sessionStorage['scroll-cache_' + gridUrl] = response;
                    } catch (e) {
                        // nothing to catch in case of out of memory of session storage
                        // it will fall back to load via ajax
                    }
                    // update UI
                    backLoadingPlaceHolder.remove(); // identifier to detect next page available or not					
                    $(".results-hits").remove();
                    if( !$.trim( $('.results-hits-empty').html() ).length ) {
                        $('.results-hits-empty').css('width', 'initial');
                    };
                    $('.product-tiles-holder').css('visibility', 'visible');
                    fillEndlessScrollChunk2(response);
                    copyBottomResultHitsToTop();
                    productTile.init();
                    $(document).trigger("plpviewmore");
                    getPageUpdateOnUrl();
                    // rebind lazyLoadingObserver after DOM updated 
                    setTimeout(function () {
                        if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
                            initPLPSlider();
                        }
                        initColorShadesSliderPlp();
                        if (!!window.IntersectionObserver) {
                            lazyLoadingBottomToTopObserver();
                        }

                        var currentCount = $('.search-result-content .product-item').length;
                        var totalCount = $('#total-count').val();
                        $('.current-count').html($('.search-result-content .product-item').length  + ' of');
                        if (currentCount == totalCount) {
                            $('.current-count').empty();
                        }
                    }, 1000);
                }
            });
        }
    }
}

//maintain scroll postion
function maintainBackPageScroll() {
    var divScroll = localStorage.getItem("tempProductPosition") != null ? localStorage.getItem("tempProductPosition") : localStorage.getItem("productPositionLastClicked");

    if (divScroll != null && $('#' + divScroll).offset() != undefined) {
        $('html, body').animate({ scrollTop: $('#' + divScroll).offset().top - $(".sticky-header").outerHeight() }, 100);
    }

    localStorage.setItem("tempProductPosition", document.getElementsByClassName("product-item")[0].id);
}

//observer bottom to top - lazy loading
function lazyLoadingBottomToTopObserverHandler(entries, observer) {
    if (!$(".back-page").hasClass("temp-hide")) {
        for (var entry of entries) {
            if (entry.intersectionRatio >= 0.85) {
                viewBottonToTopClick();
            }
        }
    }
}

//on back button highlighting div
function onReloadMaintainScroll() {
    if (window.location.href.indexOf("#") > -1 && localStorage.getItem("productPositionLastClicked")) {
        var divScroll = localStorage.getItem("productPositionLastClicked");
        if ($('#' + divScroll).offset() != undefined) {
            $('html, body').animate({ scrollTop: $('#' + divScroll).offset().top - $(".sticky-header").outerHeight() }, 100);
        }

    }
}

//Lazy loading - loading initialisation
function postObserverAct() {
    $('html').removeClass('disable-scroll');
    $('.product-loader').removeClass('is-active');
    onReloadMaintainScroll();
    $(".next-page").removeClass("temp-hide");
    $(".back-page").removeClass("temp-hide");

    //initialize back to top scroll lazy load
    if (!!window.IntersectionObserver) {
        lazyLoadingBottomToTopObserver();
    }
    // to check IntersectionObserver supports or not
    updateIntersectionObserver();
    getPageUpdateOnUrl();
}

// add Loader when PLP is back navigated
function addLoader() {
    if (window.location.href.indexOf("#") > -1 && localStorage.getItem("productPositionLastClicked")) {
        $('.product-loader').addClass('is-active');
        $('html').addClass('disable-scroll');
    }
}

// sorting rule default selected
function rankDefaullSelected() {
	let rankDefaullValue = $("#grid-sort-header").find(':selected').attr('value');
	let rankDefaullSelected = rankDefaullValue.match(/rule=rank/gi);

	if (rankDefaullSelected != undefined && $("#grid-sort-header").find(':selected')) {
		$("#grid-sort-header").find(':selected').trigger('change');
	}
}

$(window).on('load', function () {
    localStorage.removeItem("tempProductPosition");
    $('.current-count').html($('.search-result-content .product-item').length + ' of');
    setTimeout(postObserverAct, 500);
    if ($('.pt_product-search-result').length && $("#grid-sort-header").find(':selected').filter("[value]").length > 0) {
        rankDefaullSelected();
    }
});


/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url) {
    if (!url || url === window.location.href || url == "javascript:void(0)") {
        return;
    }
    progress.show($('.search-result-content'));
    $('#main').load(util.appendParamToURL(url, 'format', 'ajax'), function () {
        $(document).foundation();
        compareWidget.init();
        productTile.init();        
        progress.hide();
        history.pushState(undefined, '', url);
        if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
            initPLPSlider();
        }
        initColorShadesSliderPlp();
    });
}

function excludeCompoundAttributeRefinements(refineUrl) {
    var newUrl = refineUrl;

    var params = util.getQueryStringParams(refineUrl);
    Object.keys(params).forEach(function (paramName) {
        if (paramName.indexOf('prefv') === -1) {
            return;
        }

        var splitParam = params[paramName].split("|");
        newUrl = util.updateQueryStringParam(newUrl, paramName, splitParam[splitParam.length - 1]);
    });

    return newUrl;
}

if (screen.width > 1024){
	$("#grid-sort-header").focusin(function() {
		$("#wrapper").css("overflow-y","hidden");
	});
	
	$(".filter-option").click(function() {
		$("#wrapper").css("overflow-y","hidden");
	});
}


/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    var $main = $('#main');
    // compare checked
    $main.on('click', 'input[type="checkbox"].compare-check', function () {
        var cb = $(this);
        var tile = cb.closest('.product-tile');

        var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
        var itemImg = tile.find('.product-image a img').first();
        func({
            itemid: tile.data('itemid'),
            uuid: tile[0].id,
            img: itemImg,
            cb: cb
        });

    });

    $(document).on("click", ".top-filter a.filter-option", function(e) {
        e.preventDefault();
        var $this = $(this);
        if(!$this.parent().hasClass("disabled-filter-item")) {
            $this.toggleClass("checked-filter");
            var url = $this.attr( $this.hasClass("checked-filter") ? 'data-refineurl': 'data-relaxurl' ) ;
            updateProductListing(url);
        }
    });
    
    $(document).on("click", ".selected-breadcrumb-refinement a.breadcrumb-relax", function(e) {
        e.preventDefault();
        var $this = $(this);
        var url = $this.attr('data-relaxurl') ;
        updateProductListing(url);
    });

    // handle events for updating grid
    $main.on('click', '.refinements a, .pagination a, .breadcrumb-refinement-value a', function (e) {
        // don't intercept for category and folder refinements, as well as unselectable
        if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
            return;
        }
        e.preventDefault();
        updateProductListing(this.href);
    });

    // handle sorting change
    $main.on('change', '.sort-by select', function (e) {
        e.preventDefault();
        updateProductListing($(this).find('option:selected').val());
    })
    .on('change', '.items-per-page select', function () {
        var refineUrl = $(this).find('option:selected').val();
        if (refineUrl === 'INFINITE_SCROLL') {
            $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
        } else {
            $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
            updateProductListing(refineUrl);
        }
    });

    //handle refinement change
    //$main.on('click', 'ul.product-listing-filter li a', function (e) {
   
   
    
    /* .on('change', '.items-per-page select', function() {
    		var refineUrl = $(this).find('option:selected').val();
    		$('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
    		updateProductListing(refineUrl);
	}); */



    $('.category-tab-links select').on('change', function(e){
    	var $selected = $(this).find(":selected");
    	var link = $selected.attr('href');

    	if(link){
    		window.location.href = link;
    	}
    });

}
var initColorShadesSliderPlp = function() {
    let isDesktop = window.matchMedia("(min-width: 890px)").matches;
    let slideCount = isDesktop ? 7 : 5;

    $('.pt_product-search-result .product-variations #pdp-swatches').each(function () {
        let slider = $(this);
        let totalSlides = $(this).find("li").length;
        let selectedSlideIndex = $(this).find("li.selected").index();

        if(totalSlides > slideCount && !$(this).hasClass("slick-initialized")) {
			$(slider).slick({
                initialSlide: selectedSlideIndex - 5,
				autoplay: false,
				dots: false,
				arrows: true,
				infinite: true,
                variableWidth: true,
				slidesToShow: 7,
                slidesToScroll: 6,
                swipe: true,
				responsive: [
					{
						breakpoint: 890,
						settings: {
                            initialSlide: selectedSlideIndex - 2,
                            slidesToShow: 5,
                            slidesToScroll: 4
						}
					}
				]
			});
		}// Initialize the Slick slider
	});
}

var initPLPSlider = function(val) {
	// for each loop to initialize slider
	var isDesktop = window.matchMedia("(min-width: 1025px)").matches;
	$('.product-item .product-slick-track').each(function () {
		var slider = $(this);
		if(!$(this).hasClass("slick-initialized")) {
			$(slider).slick({
				initialSlide: 0,
				autoplay: false,
				dots: false,
				arrows: true,
				infinite: false,
				speed: 150,
				slidesToShow: 1,
                fade: true,
                cssEase: 'linear',
				responsive: [
					{
						breakpoint: 1024,
						settings: {
						arrows: false,
						dots: true,
						}
					}
				]
			});
		}// Initialize the Slick slider
		
		var timer;
		var manualNavigation = false;

        // added to handle additional anchor tag in search overlay
        if(val == true) {
            $(slider).on('init afterChange', function (event, slick) {
                if(slick.slideCount <= 2) {
                    $(this).find(".slick-arrow").addClass("hide-slick-arrow");
                } else {
                    $(this).find(".slick-arrow").addClass("show-slick-arrow");
                }
            }); 
        }

		$(slider).on({
			/**
			 * If the user has not manually navigated, shows the second slide after a delay.
			 *
			 */
			mouseenter: function () {
				clearTimeout(timer);
				// If the user has not manually navigated, show the second slide
				if (manualNavigation !== true && isDesktop) {
					var currentIndex = slider.slick('slickCurrentSlide');
					if (currentIndex !== undefined) {
						timer = setTimeout(function () {
							if (currentIndex === 0) { // If the current slide is the first slide
                                if(val == true) {
								    slider.slick('slickGoTo', 2); // Show the second slide
                                } else {
								    slider.slick('slickGoTo', 1); // Show the second slide
                                }
							}
						}, 100);
					}
				}
			},
			mouseleave: function () {
				clearTimeout(timer);

				// If the user has not manually navigated, revert to the first slide
				if (manualNavigation !== true && isDesktop) {
					var currentIndex = slider.slick('slickCurrentSlide');
					if (currentIndex !== undefined) {
						timer = setTimeout(function () {
							if (currentIndex !== 0) { // If the current slide is not the first slide
								slider.slick('slickGoTo', 0); // Show the first slide
							}
						}, 100);
					}
				}
			}
		});

		/**
   * Sets a flag to indicate that the user has manually navigated the slider.
   * This is triggered when the user clicks on a slider arrow.
   */
		$(slider).on('click', '.slick-arrow', function () {
			if ($(this).length) { // Check if the element exists
				manualNavigation = true; // Set manual navigation flag
			}
		});
	});
}

exports.init = function () {

    addLoader();
    video.init();
    filterPanel.init();
    compareWidget.init();
    //$("#view-more").on("click", viewMoreClick);

    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $(window).on('scroll', viewMoreClick);
    }
    productTile.init();
    initializeEvents();
    if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
        initPLPSlider();
    }
    initColorShadesSliderPlp();
    // content navigation title link
    $('.nav.content-navigation .accordion-title span').on('click', function() {
    	window.location = $(this).data('url');
    });

    // content navigation dropdown redirect
    $('.nav.content-navigation select').on('change', function() {
    	window.location = $(this).val();
    });


    $(document).on('click', '.refinements .accordion-arrow', function(evt) {
        evt.preventDefault();
        $(this).next('#category-level-2').slideToggle();
        $(this).parent('li').toggleClass('expanded');
    });



};
exports.viewMore = function() {
	//$(document).on("click", "#view-more", viewMoreClick);
	if (SitePreferences.LISTING_INFINITE_SCROLL) {
      $(window).on('scroll', viewMoreClick);
    }
};

exports.initPLPSlider = initPLPSlider;
exports.initColorShadesSliderPlp = initColorShadesSliderPlp;

export default {
    init: function () {
        exports.init();
    },
    viewMore: function () {
        exports.viewMore();
    },
    initPLPSlider: function () {
        exports.initPLPSlider();
    },
    initColorShadesSliderPlp: function () {
        exports.initColorShadesSliderPlp();
    }
};